import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Reveal from '@/components/feature/Reveal';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface Highlight {
  icon: string;
  title: string;
}

export default function About() {
  const { t } = useTranslation();
  const highlights = t('about.section.highlights', { returnObjects: true }) as Highlight[];

  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-20 pb-12">
        <div className="w-full px-4 md:px-6 py-16">
          <div className="text-center mb-14 md:mb-16">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-50 text-accent-700 text-xs font-semibold mb-4">
              <i className="ri-team-line"></i>
              {t('about.badge')}
            </span>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-4">{t('about.title')}</h1>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
              {t('about.subtitle')}
            </p>
          </div>

          <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <Reveal>
              <div className="relative w-full aspect-[4/5] overflow-hidden rounded-lg bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20facility%20maintenance%20worker%20in%20a%20crisp%20modern%20uniform%20carefully%20cleaning%20the%20bright%20glass%20entrance%20of%20a%20contemporary%20Swiss%20office%20building%2C%20warm%20natural%20sunlight%20streaming%20in%2C%20minimalist%20corporate%20architecture%20with%20clean%20lines%2C%20subtle%20indoor%20plants%2C%20editorial%20corporate%20photography%2C%20soft%20neutral%20tones%2C%20premium%20and%20elegant%20atmosphere&width=1200&height=1400&seq=limpia-about-01&orientation=portrait"
                  alt={t('about.imageAlt')}
                  title={t('about.imageAlt')}
                  className="h-full w-full object-cover object-top"
                />
              </div>
            </Reveal>

            <div>
              <Reveal>
                <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-6">
                  {t('about.section.headline')}
                </h2>
              </Reveal>

              <Reveal delay={100}>
                <div className="space-y-4 text-foreground-600 text-sm md:text-base leading-relaxed">
                  <p>{t('about.section.paragraph1')}</p>
                  <p>{t('about.section.paragraph2')}</p>
                  <p>{t('about.section.paragraph3')}</p>
                </div>
              </Reveal>

              <Reveal delay={200}>
                <div className="mt-8 flex flex-wrap gap-3">
                  {highlights.map((item) => (
                    <div
                      key={item.title}
                      className="flex items-center gap-3 rounded-lg bg-background-100 border border-background-200/70 px-4 py-3"
                    >
                      <div className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
                        <i className={`${item.icon} text-base`}></i>
                      </div>
                      <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.title}</span>
                    </div>
                  ))}
                </div>
              </Reveal>

              <Reveal delay={300}>
                <Link
                  to="/services"
                  className="mt-8 inline-flex items-center gap-2 rounded-md bg-primary-500 text-background-50 px-6 py-3 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {t('about.section.cta')}
                  <i className="ri-arrow-right-line text-base"></i>
                </Link>
              </Reveal>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}